import React from 'react';

import CompleteProfileMyProfileForm from '../forms/CompleteProfileMyProfileForm';


class CompleteProfileStep2 extends React.Component {

    constructor(props) {
        super(props);
    }

    submit(e) {
        e.preventDefault();

        const data = this.refs.form.getValue();
        const errors = this.refs.form.validate(true).errors;
        if (Object.keys(errors).length > 0) {
            const smoothScroll = setInterval(() => {
                window.scrollBy(0, -40);
                const scrollTarget = this.refs.completeProfileStep2.getDOMNode().offsetTop + 90;
                const scrollTop = document.body.scrollTop;
                if (scrollTop <= scrollTarget) {
                    clearInterval(smoothScroll);
                }
            }, 16);
            this.props.mergeErrorsIntoState(errors);
        } else if (data) {
            this.props.addData(data);
            this.props.mergeErrorsIntoState({});
            this.props.changeStep.call(this, 3, true);
        }
    }

    render () {
        const errors = this.props.errors;
        const phone = this.props.user.profile.profile.phone

        return (
            <div ref="completeProfileStep2" className="complete-profile-step-content complete-profile-step2">
                <form onSubmit={this.submit.bind(this)} noValidate>
                    <CompleteProfileMyProfileForm initialFormData={{phone}} errors={errors} ref="form" />

                    <div>
                        <button className="btn btn-small btn-green" type="submit">Continue</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default CompleteProfileStep2;



/** WEBPACK FOOTER **
 ** ./app/src/components/CompleteProfileStep2.js
 **/